import { body, request } from "services/request";

const resource = "api/counter";

export const increase = (params: {}) => request(`${resource}/increase`, body(params));
